import React, { Dispatch, SetStateAction } from "react";

import { Asset } from "sfmc";

import { ThumbnailType, Video } from "vimeo";

import { EmbedInEmailSource } from "../analytics/common";

export interface EmbedInEmailContextState {
    source: EmbedInEmailSource;
    video: Video;
    videoId: string;
    name: string;
    link: string;
    selectedImgType: ThumbnailType;
    imgUrl: string;
    imgUrlWithPlayButton: string;
    /**
     * Boolean to indicate if the selected image/gif is a portrait resolution.
     */
    isPortraitImage: boolean;
    createAssetWithPlayButton: boolean;
    asset: Asset;
}

// The argument passed to createContext simply mimics React's useState()
// semantics.
const EmbedInEmailContext = React.createContext<
    [
        Partial<EmbedInEmailContextState>,
        Dispatch<SetStateAction<Partial<EmbedInEmailContextState>>>
    ]
>([{}, () => {}]);

export default EmbedInEmailContext;
